import { MDBBtn,MDBIcon } from 'mdbreact';
import React, { useState } from 'react';
import { Card, CardBody, Col, Collapse, Container, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, Media, Row } from "reactstrap";

const ModalPersonalizado = props => {
    const [sideAbierto, setSide] = useState(false);
    return (
        <div>
            <Row className="align-items-center justify-content-center">
                <Col lg={3}>
                    <MDBBtn className="waves-effect" color="success" onClick={() => setSide(true)}>
                        Abrir Vista {props.titulo}
                    </MDBBtn> {" "}
                </Col>
            </Row>
            <br />
            <Modal isOpen={sideAbierto} size="mm">
                <Row className="align-items-center justify-content-center">
                    <span className="text-center"><strong>{props.titulo}</strong></span>
                </Row>
                <hr />
                &nbsp;
                <Row className="scrollableY">
                    {props.contenido}
                    <Col lg={12}>
                        <MDBBtn className="waves-effect" color="danger" onClick={() => setSide(false)} >
                            <MDBIcon icon="fas fa-arrow-left"/>
                            {' '}
                            Cerrar Vista {props.titulo}
                        </MDBBtn>
                        {" "}
                    </Col>
                </Row>
            </Modal>
        </div>
    );
}

export default ModalPersonalizado;